import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MDPhysicallyHandicappedBodyModel } from 'src/app/model/MDPhysicallyHandicappedBodyModel';
import { RegistrationModerationDocumentModel } from 'src/app/model/RegistrationModerationDocumentModel';

@Component({
  selector: 'app-secure-md-physically-handicapped',
  templateUrl: './md-physically-handicapped.component.html',
  styleUrls: []
})
export class MDPhysicallyHandicappedComponent implements OnInit {
  @Input() registrationModerationDocument: RegistrationModerationDocumentModel;
  verifyForm: FormGroup = new FormGroup({});
  isVerifyDisabled: boolean;
  verifyErrorMessage: string;
  @Output() onSubmit = new EventEmitter<MDPhysicallyHandicappedBodyModel>();
  departments: string[] = [];

  constructor() { }

  ngOnInit(): void { 
    console.log(this.registrationModerationDocument);
    this.verifyForm = new FormGroup({
      nameAsOnCertificate: new FormControl(null, [Validators.required]),
      phDocumentType: new FormControl(null, [Validators.required]),
      phDocumentNo: new FormControl(null, [Validators.required]),
      disabilityPercentage: new FormControl(null, [Validators.required]),
    });
  }

  onSubmitVerify() {
    console.log('verify submit clicked', this.verifyForm);
    this.verifyErrorMessage = null;
    if (this.verifyForm.valid) {
      this.onSubmit.emit(new MDPhysicallyHandicappedBodyModel(
        this.verifyForm.value.nameAsOnCertificate,
        this.verifyForm.value.phDocumentType,
        this.verifyForm.value.phDocumentNo,
        this.verifyForm.value.disabilityPercentage,
        ));
    }
    else {
      this.verifyErrorMessage = "Please enter all mandatory fields";
      this.isVerifyDisabled = false;
    }
  }
}
